// extracted by mini-css-extract-plugin
export var children_section = "CafeteraBotones-module--children_section--dc8a1";
export var children_section2 = "CafeteraBotones-module--children_section2--adb9a";
export var container2 = "CafeteraBotones-module--container2--1994f";
export var container_filtros = "CafeteraBotones-module--container_filtros--24e70";
export var container_img = "CafeteraBotones-module--container_img--b7adf";
export var container_img2 = "CafeteraBotones-module--container_img2--1b085";
export var container_inf = "CafeteraBotones-module--container_inf--8ae9b";
export var container_section = "CafeteraBotones-module--container_section--7aafb";
export var img_item = "CafeteraBotones-module--img_item--7c3a9";
export var img_item2 = "CafeteraBotones-module--img_item2--c129d";
export var img_item3 = "CafeteraBotones-module--img_item3--410a0";
export var nextButton = "CafeteraBotones-module--nextButton--ba4be";
export var postion_section2 = "CafeteraBotones-module--postion_section2--66421";
export var postion_section3 = "CafeteraBotones-module--postion_section3--e3cb1";
export var postion_section4 = "CafeteraBotones-module--postion_section4--d2a65";
export var previousButton = "CafeteraBotones-module--previousButton--591a8";